/**
 * handles the header menu dropdowns
 * @todo namespacing
 */

import $ from 'jquery';

export default class HeaderNavigation {

	/**
	 *
	 */
	constructor(options) {
		this.id = options.id;
		this.dropdownId = options.dropdownId;
		this.buttonClassName = options.buttonClassName;

		this.events = options.events;

		this.dropdown = new options.Dropdown({
			id: this.dropdownId
		});

		this.menu = new options.Menu({
			id: this.dropdownId + '-menu',
			rootId: this.dropdownId,
			events: this.events
		});

		this.title = new options.Title({
			id: this.dropdownId + '-title',
			rootId: this.dropdownId,
		});

		this.closeButton = new options.CloseButton({
			id: this.dropdownId + '-close-button',
			rootId: this.dropdownId,
			events: this.events
		});

		this.init.call(this);

	}

	/**
	 * @chainable
	 */
	init() {
		this.setLinks();
		this.listeners = this.registerListeners();
		this.events.addListener('menu--close', this.closeMenu.bind(this));
		return this;
	}

	/**
	 * @chainable
	 */
	setLinks() {
		this.links = Array.prototype.slice.call(document.getElementsByClassName(this.buttonClassName))
		return this;
	}

	/**
	 * @param Array
	 * @return Array
	 */
	registerListeners() {
		return this.links.map((link) => { return link.addEventListener('click', this.onClick.bind(this)) })
	}

	/**
	 *
	 */
	deregisterListeners() {
	}

	/**
	 * @chainable
	 * @todo abstract configure methods, element toggling, and multiple link selections
	 *
	 */
	onClick(event) {
		event.preventDefault();
		this.dropdown.configure(event.target.dataset).show();
		this.menu.configure(event.target.dataset).show();
		this.title.configure(event.target.dataset).show();
		this.events.emit('menu--open');
		return this;
	}

	closeMenu(event) {
		this.dropdown.close().reset();
		this.menu.hide().reset();
		this.title.hide();
	}

}